import startStepRecorder from 'shared/lib/step-recorder';
import takeScreenshot from 'shared/lib/take-screenshot';
import startVideoRecording from 'shared/lib/video-recording';

export default function render(browser, iframeURL, extensionId) {
  const popupId = 'one-click-to-notion';
  const top = 20;
  const right = 20;

  function getHTMLOfSelection() {
    let range;
    if (document.selection && document.selection.createRange) {
      range = document.selection.createRange();
      return range.htmlText;
    }
    if (window.getSelection) {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        range = selection.getRangeAt(0);
        const clonedSelection = range.cloneContents();
        const div = document.createElement('div');
        div.appendChild(clonedSelection);
        return div.innerHTML;
      }

      return '';
    }

    return '';
  }

  const getThumbnail = () => {
    const ogImage = document.querySelector('meta[property="og:image"]');
    if (ogImage === null) {
      return '';
    }
    return ogImage.content;
  };
  const selection = getHTMLOfSelection();
  const selectionText = window.getSelection().toString();

  let iframeWrapper;
  let iframeElement;

  let clientX = 0;
  let clientY = 0;

  const handleDragStart = (event) => {
    clientY = event.clientY;
    clientX = event.clientX;

    document.addEventListener('mouseup', handleDragEnd);
    document.addEventListener('mousemove', handlePageMousemove);
  };

  const handleDragEnd = () => {
    document.removeEventListener('mouseup', handleDragEnd);
    document.removeEventListener('mousemove', handlePageMousemove);
  };

  const handlePageMousemove = (event) => {
    const top = parseInt(iframeWrapper.style.top, 10);
    const right = parseInt(iframeWrapper.style.right, 10);
    iframeWrapper.style.top = `${top - clientY + event.clientY}px`;
    iframeWrapper.style.right = `${right + clientX - event.clientX}px`;
    clientX = event.clientX;
    clientY = event.clientY;
  };

  window.onmessage = (event) => messageListener(event);
  const messageListener = async (evt) => {
    const data = evt.data;

    switch (data.msg) {
      case 'NOTIX_DRAG_START':
        handleDragStart(data.mouseX, data.mouseY);
        break;
      case 'NOTIX_DRAG_END':
        handleDragEnd();
        break;
      case 'NOTIX_CLOSE_POPUP':
        hide();
        break;
      case 'NOTIX_COPY_TO_CLIPBOARD':
        navigator.clipboard.writeText(data.payload);
        break;
      case 'NOTIX_READY':
        if (iframeElement === null || iframeElement.contentWindow === null) {
          return;
        }
        iframeElement.contentWindow.postMessage({ id: 'NOTIX_READY_RESPONSE', payload: { selection, selectionText, thumbnail: getThumbnail(), innerText: document.body.innerText, url: document.URL, title: document.title, cookie: document.cookie, localStorage: JSON.stringify(window.localStorage) } }, '*');
        break;
      case 'NOTIX_TAKE_SCREENSHOT':
        takeScreenshot(browser, extensionId, data.options);
        break;
      case 'NOTIX_RECORD_STEPS':
        startStepRecorder(browser, extensionId);
        break;
      case 'NOTIX_START_VIDEO_RECORDING':
        startVideoRecording(browser, extensionId, data.options);
        break;
      case 'NOTIX_STORAGE_LOCAL_GET':
        browser.storage.local.get(data.args.key).then((res) => {
          iframeElement.contentWindow.postMessage({ msg: 'NOTIX_STORAGE_LOCAL_GET_RESPONSE', payload: res, uid: data.uid }, '*');
        });
        break;
      case 'NOTIX_STORAGE_LOCAL_SET':
        browser.storage.local.set(data.args.payload).then((res) => {
          iframeElement.contentWindow.postMessage({ msg: 'NOTIX_STORAGE_LOCAL_SET_RESPONSE', payload: res, uid: data.uid }, '*');
        });
        break;
      case 'NOTIX_STORAGE_LOCAL_REMOVE':
        browser.storage.local.remove(data.args.key).then(() => {
          iframeElement.contentWindow.postMessage({ msg: 'NOTIX_STORAGE_LOCAL_REMOVE_RESPONSE', payload: null, uid: data.uid }, '*');
        });
        break;
      case 'NOTIX_BROWSER_TABS_QUERY':
        browser.runtime.sendMessage({ msg: 'browser.tabs.query', payload: data.args.payload }).then((res) => {
          iframeElement.contentWindow.postMessage({ msg: 'NOTIX_BROWSER_TABS_QUERY_RESPONSE', payload: res, uid: data.uid }, '*');
        });
        break;
      case 'NOTIX_RUNTIME_SENDMESSAGE':
        browser.runtime.sendMessage(extensionId, data.args.payload).then((res) => {
          iframeElement.contentWindow.postMessage({ msg: 'NOTIX_RUNTIME_SENDMESSAGE_RESPONSE', payload: res, uid: data.uid }, '*');
        });
        break;
      default:
    }
  };

  const show = () => {
    iframeWrapper = document.createElement('div');
    iframeWrapper.id = popupId;
    iframeWrapper.style = `background: #FFFEFC; position: fixed; top: ${top}px; right: ${right}px; z-index: 100000000000000000000; border-radius: 4px; box-shadow: rgba(38, 50, 56, .05) 0 0 0 1px, rgba(38, 50, 56, .1) 0 3px 6px, rgba(38, 50, 56, .2) 0 9px 24px; overflow: hidden`;

    const header = document.createElement('div');
    header.style = 'cursor: grab; height: 16px; width: 100%; border-bottom: 1px solid rgba(55, 53, 47, .09);';
    header.onmousedown = handleDragStart;

    const button = document.createElement('button');
    button.innerHTML = `<svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
        >
        <path
    d="M20 6.03636L17.9636 4L12 9.96364L6.03636 4L4 6.03636L9.96364 12L4 17.9636L6.03636 20L12 14.0364L17.9636 20L20 17.9636L14.0364 12L20 6.03636Z"
    fill="currentColor"
        />
        </svg>`;
    button.style = 'cursor: pointer; font-size: 10px; display: flex; align-items: center; justify-content: center; padding: 0; margin-top: 2px; margin-left: 6px; height: 14px; width: 14px; border-radius: 7px; border: none; background: rgba(55, 53, 47, .09);';
    button.onmouseover = () => {
      button.style.background = '#e7758fff';
    };
    button.onmouseleave = () => {
      button.style.background = 'rgba(55, 53, 47, .09)';
    };
    button.onmousedown = (event) => event.stopPropagation();
    button.onclick = hide;

    header.appendChild(button);
    iframeWrapper.appendChild(header);

    iframeElement = document.createElement('iframe');
    iframeElement.setAttribute('id', 'my-iframe');
    iframeElement.src = iframeURL;
    iframeElement.allow = 'camera; microphone';
    iframeElement.sandbox = 'allow-scripts allow-same-origin allow-forms allow-popups';
    iframeElement.style = 'background: white; width: 417px; height: 800px; max-height: 80vh; border-width: 0; ';
    iframeWrapper.appendChild(iframeElement);

    document.body.appendChild(iframeWrapper);
    iframeElement.focus();
  };

  const hide = () => {
    document.querySelector(`#${popupId}`).remove();
  };

  if (Array.from(document.querySelectorAll(`#${popupId}`)).length === 0) {
    show();
    return;
  }

  hide();
}
